export default __webpack_public_path__ + "static/media/choco-box.115fe10f.png";